import React from "react"
import Carousel from "react-multi-carousel"
import { StaticImage } from "gatsby-plugin-image"

import { HowBack, RevWrap, Slider } from "./styles"
import { MainWrapper } from "components"

export const ReviewAndInsta = () => {
  //carousel setting
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  return (
    <HowBack>
      <MainWrapper>
        <RevWrap>
          <Slider>
            <Carousel showDots={false} responsive={responsive}>
              <div className="y-content">
                <div className="content">
                  <Star />
                  <h5>
                    "First time going to Barragan's. I had the Chicken tortas
                    with fries. My wife had the Chicken tamales with mole` and
                    rice and beans. There was plenty of seats, and customer
                    service was very good and attentive. Cost of our meals came
                    out to $58.88. Will definitely return when in town."
                  </h5>
                  <h6>- Robert Taylor</h6>
                </div>
              </div>
              <div className="y-content">
                <div className="content">
                  <Star />
                  <h5>
                    "I find this place to be consistent with their food quality.
                    Everything always tastes good! Good Margaritas and good
                    food! You can eat inside or in their outdoor patio! They
                    have a fairly large variety of food to choose from! I think
                    you will enjoy it...plus, I believe they make their own
                    fresh chips with salsa!"
                  </h5>
                  <h6>- Anne Blosser</h6>
                </div>
              </div>
              <div className="y-content">
                <div className="content">
                  <Star />
                  <h5>
                    "We had about 25 people for a celebration of life party.
                    Carlos our server and his helpers took great care of us. The
                    food was great and served very quickly 😋 👌 😀. I highly
                    recommend this place for a great meal and friendly staff"
                  </h5>
                  <h6>- Rick. M</h6>
                </div>
              </div>
            </Carousel>
          </Slider>
          <div
            data-sal="slide-up"
            data-sal-delay="250"
            data-sal-easing="ease"
            className="insta"
          >
            <a
              href="https://www.instagram.com/barragans_restaurants/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <StaticImage
                src="../../images/instagram.jpg"
                placeholder="blurred"
                quality={100}
              />
            </a>
          </div>
        </RevWrap>
      </MainWrapper>
    </HowBack>
  )
}

const Star = () => (
  <div className="star">
    <i></i>
    <i></i>
    <i></i>
    <i></i>
    <i></i>
  </div>
)
